import type { useInterventionFollowupDropDownProps } from "@/modules/intervention/intervention-followup/intervention-followup-dropdown/intervention-followup-dropdown.type";
import type { MenuProps } from "antd";
import type { ReactNode } from "react";

import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { InterventionFollowupDropdownPopup } from "../intervention-followup-dropdown-popup";

export const useInterventionFollowupDropDown = ({
  intervention,
}: useInterventionFollowupDropDownProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const versions = intervention.followup?.versions;
  const menuItems: MenuProps["items"] = useMemo(() => {
    return versions?.map((version) => ({
      key: `version-${version.id}`,
      label: (
        <Link
          key={`version-link-${version.id}`}
          to={`/interventions/${version.id}${location.search}`}
        >
          {version.name}
        </Link>
      ),
    }));
  }, [versions, location.search]);

  const renderPopup = useCallback(
    (menu: ReactNode) => (
      <InterventionFollowupDropdownPopup
        intervention={intervention}
        menu={menu}
      />
    ),
    [intervention]
  );

  return {
    label: t("followUp:button.label"),
    menuItems,
    renderPopup,
  };
};
